(function () {
  'use strict';

  function isProtectedTarget(el) {
    return el && (el.tagName === 'IMG' || el.tagName === 'VIDEO' || el.tagName === 'SOURCE');
  }

  // Block right-click "Save image / Save video as" on media elements.
  document.addEventListener('contextmenu', function (e) {
    if (isProtectedTarget(e.target)) {
      e.preventDefault();
    }
  });

  // Block drag-to-save of images/videos.
  document.addEventListener('dragstart', function (e) {
    if (isProtectedTarget(e.target)) {
      e.preventDefault();
    }
  });

  function hardenVideo(video) {
    if (video.dataset.protected) return;
    video.dataset.protected = 'true';
    video.setAttribute('controlsList', 'nodownload noremoteplayback');
    video.setAttribute('disablePictureInPicture', '');
    video.setAttribute('oncontextmenu', 'return false');
  }

  function hardenAll(root) {
    (root || document).querySelectorAll('video').forEach(hardenVideo);
  }

  // Initial pass.
  hardenAll(document);

  // Catch videos added later (sliders, lazy sections, theme editor re-renders).
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'VIDEO') {
          hardenVideo(node);
        } else if (node.querySelectorAll) {
          hardenAll(node);
        }
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
